import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

const base = 'w-full h-11 px-4 rounded-[10px] bg-l-paper-soft border border-l-rule text-l-ink placeholder:text-l-ink-muted placeholder:italic font-sans text-[15px] focus:outline-none focus:border-l-terracotta transition-colors';

export const LInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...rest }, ref) => (
    <input ref={ref} className={cn(base, className)} {...rest} />
  ),
);
LInput.displayName = 'LInput';
